import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { saveMetrologyFailed, saveMetrologySuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* saveMetrology(action) {
  try {
    const url = `${BACKEND_URL}/api/v1/certificate`;
    const dataResponse = yield makeRequest(url, action.payload, action, 'POST', true);
    if (dataResponse.status === OK) {
      yield put(saveMetrologySuccessful());
      yield call(resolveActionPromise(action));
    } else {
      yield put(saveMetrologyFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(saveMetrologyFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
